module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "act_name"
    }
  }, [_c('el-input', {
    staticClass: "el-form-item-300",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.act_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "act_name", $$v)
      },
      expression: "form.act_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "start_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "请选择开始时间",
      "size": "small",
      "clearable": false,
      "picker-options": _vm.dateRange
    },
    model: {
      value: (_vm.form.start_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_time", $$v)
      },
      expression: "form.start_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "expire_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "请选结束时间",
      "size": "small",
      "clearable": false,
      "picker-options": _vm.dateRange
    },
    model: {
      value: (_vm.form.expire_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "expire_time", $$v)
      },
      expression: "form.expire_time"
    }
  })], 1), _vm._v(" "), (!_vm.role.single) ? _c('el-form-item', {
    attrs: {
      "label": "适用门店",
      "prop": "sub_mchnt_list"
    }
  }, [_c('el-select', {
    ref: "selectShops",
    attrs: {
      "placeholder": "请选择门店",
      "multiple": "",
      "size": "small"
    },
    model: {
      value: (_vm.form.sub_mchnt_list),
      callback: function($$v) {
        _vm.$set(_vm.form, "sub_mchnt_list", $$v)
      },
      expression: "form.sub_mchnt_list"
    }
  }, _vm._l((_vm.shopList), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "红包金额"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.packetValue),
      callback: function($$v) {
        _vm.packetValue = $$v
      },
      expression: "packetValue"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("固定金额")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("随机金额")])], 1)], 1), _vm._v(" "), (_vm.packetValue === 0) ? [(_vm.packetValue === 0) ? _c('el-form-item', {
    attrs: {
      "label": "单个红包金额"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "singleValue"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.singleValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "singleValue", _vm._n($$v))
      },
      expression: "form.singleValue"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "红包个数"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "coupon_num"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.coupon_num),
      callback: function($$v) {
        _vm.$set(_vm.form, "coupon_num", _vm._n($$v))
      },
      expression: "form.coupon_num"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("个")])], 1)] : _vm._e(), _vm._v(" "), (_vm.packetValue === 1) ? [_c('el-form-item', {
    attrs: {
      "label": "单个红包金额"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amt_min"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.form.amt_min),
      callback: function($$v) {
        _vm.$set(_vm.form, "amt_min", _vm._n($$v))
      },
      expression: "form.amt_min"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "amt_max"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.form.amt_max),
      callback: function($$v) {
        _vm.$set(_vm.form, "amt_max", _vm._n($$v))
      },
      expression: "form.amt_max"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "红包总预算"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "total_amt"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.total_amt),
      callback: function($$v) {
        _vm.$set(_vm.form, "total_amt", _vm._n($$v))
      },
      expression: "form.total_amt"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元")]), _vm._v(" "), _c('span', {
    staticClass: "remark ml-10"
  }, [_vm._v("* 红包金额领取后被使用，才会消耗预算")])], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "领取条件"
    }
  }, [_c('span', [_vm._v("微信支付满")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "obtain_amt"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.obtain_amt),
      callback: function($$v) {
        _vm.$set(_vm.form, "obtain_amt", _vm._n($$v))
      },
      expression: "form.obtain_amt"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元可领取")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用条件"
    }
  }, [_c('span', [_vm._v("微信支付")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "limit_amt"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.limit_amt),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_amt", _vm._n($$v))
      },
      expression: "form.limit_amt"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元以上可用")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生效日期",
      "prop": "effect_offset"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.effect_offset),
      callback: function($$v) {
        _vm.$set(_vm.form, "effect_offset", $$v)
      },
      expression: "form.effect_offset"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("即刻生效")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("次日生效")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "红包有效期"
    }
  }, [_c('span', [_vm._v("领取后")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "effect_date"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.form.effect_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "effect_date", _vm._n($$v))
      },
      expression: "form.effect_date"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("天内可使用")]), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_c('p', [_vm._v("注：")]), _vm._v(" "), _c('p', [_vm._v("1、红包费用由商户承担；")])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3762dd4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/packetshare/packetshare.vue
// module id = 811
// module chunks = 1